module.exports = __webpack_public_path__ + "img/tr.d6f232d7.svg";